module.exports = __webpack_public_path__ + "static/image/company/pc/image_conduct_3@3x.jpg?e80e810c";